import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import {
  SubmitBatchPaymentRepository,
  PaymentActionResponse,
} from "features/stock-ordering/data/stock-ordering.repository";

export interface SubmitBatchPaymentParam {
  orderIds: number[];
  paymentProof: File;
  remarks?: string;
}

export enum SubmitBatchPaymentState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: SubmitBatchPaymentState;
  message: string;
}

const initialState: InitialState = {
  status: SubmitBatchPaymentState.initial,
  message: "",
};

export const submitBatchPayment = createAsyncThunk(
  "submitBatchPayment",
  async (param: SubmitBatchPaymentParam, { rejectWithValue }) => {
    try {
      const response: PaymentActionResponse =
        await SubmitBatchPaymentRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  },
);

export const submitBatchPaymentSlice = createSlice({
  name: "submitBatchPayment",
  initialState,
  reducers: {
    resetSubmitBatchPayment: (state) => {
      state.status = SubmitBatchPaymentState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitBatchPayment.pending, (state) => {
        state.status = SubmitBatchPaymentState.inProgress;
      })
      .addCase(submitBatchPayment.fulfilled, (state, action) => {
        if (action.payload) {
          state.status = SubmitBatchPaymentState.success;
          state.message = action.payload.message;
        }
      })
      .addCase(submitBatchPayment.rejected, (state, action) => {
        state.status = SubmitBatchPaymentState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectSubmitBatchPayment = (state: RootState) =>
  state.submitBatchPayment;
export const { resetSubmitBatchPayment } = submitBatchPaymentSlice.actions;
export default submitBatchPaymentSlice.reducer;
